var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-.55 0-1.06.3-1.32.78l-9.5 17c-.28.5-.27 1.11.02 1.6s.81.79 1.38.79h19c.57 0 1.09-.3 1.38-.79s.3-1.1.02-1.6l-9.5-17C13.06 2.3 12.55 2 12 2m1 14h-2v-2h2zm0-4h-2V8h2z"
  })));
};
export default SvgWarning;